export const DIALOG_WINDOW_SET_WINDOW = 'dialog.window.SET_WINDOW';
export const DIALOG_WINDOW_REMOVE_WINDOW = 'dialog.window.REMOVE_WINDOW';
export const DIALOG_WINDOW_HIGHLIGHTED_WINDOW = 'dialog.window.HIGHLIGHTED_WINDOW';
export const RESET_WINDOW = 'RESET_WINDOW';
